import React from "react";
import Widget from "../../../components/Widget/index";
import AboutItem from "./AboutItem";
class About extends React.Component {
  render() {
    return (
      <Widget styleName="jr-card-full jr-card-tabs-right jr-card-profile">
        <div className="card-header">
          <h4 className="card-title mb-0">About</h4>
        </div>
        <div className="jr-tabs-classic">
          <div className="jr-tabs-content jr-task-list">
            <div className="row">
              {this.props.aboutList.map((about, index) =>
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" key={index}><AboutItem data={about} /></div>)}
            </div>
          </div>
        </div>
      </Widget>
    );
  }
}
export default About;
